export default __webpack_public_path__ + "static/media/steps.86e79df0.svg";